export const GET_TEMPLATE_BY_ID = `
import AFLNFT from 0xAFLContracts

access(all) fun main(templateId:UInt64): AFLNFT.Template {
  return AFLNFT.getTemplateById(templateId:templateId)
}
`
